<template>
  <email-address
    :model-value="modelValue"
    :placeholder="defaultEmail ? `${defaultEmail} (Auto)` : placeholder"
    :disable="disable"
    :input-class="{'dark-placeholder': !!defaultEmail}"
    :error="!disable && !checkEmailValid(modelValue || defaultEmail)"
    :error-message="invalidEmailError"
    dense
    outlined
    hide-bottom-space
    clearable
    autocomplete="none"
    @update:model-value="onSelectValue($event)"
    @focus="$emit('focus')"
  >
    <template v-if="mobileMode" #append>
      <q-btn
        dense
        flat
        icon="mdi-dots-vertical"
        @click="$refs.menu.open()"
      />
    </template>

    <responsive-menu
      ref="menu"
      toolbar-title="Suggested Emails"
      no-parent-event="mobile"
      force-on-mobile
      autoclose
      fit
      max-width="450px"
      :breakpoint="1024"
    >
      <template v-if="!disable && !modelValue && defaultEmail && prefillHint">
        <q-item-wrapper
          icon="mdi-email-sync"
          label-class="text-bold text-blue-grey-8"
          :label="prefillHint"
        />
        <q-separator inset />
      </template>
      <EmailSuggestionList
        v-if="suggestions.length > 0"
        :model-value="modelValue"
        :list="suggestions"
        style="min-width: 250px;"
        @update:model-value="onSelectValue"
      />
      <q-item-wrapper
        v-else
        dense
        label="No suggested emails to display"
        label-class="text-bold"
      />
    </responsive-menu>
  </email-address>
</template>

<script>
import EmailSuggestionList from 'components/partials/communications/email/EmailSuggestionList'

/**
 * EmailInput can provide suggestions for applicable email addresses
 * Also highlights in red if email *might* be invalid
 * Please refer to ReminderList for details
 */
export default {
  components: {
    EmailSuggestionList
  },
  props: {
    modelValue: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Enter email address...'
    },
    disable: {
      type: Boolean,
      default: false
    },
    defaultEmail: {
      type: String,
      default: null
    },
    prefillHint: {
      type: String,
      default: 'Email is set to automatically prefill. Changing the email on the client profile will automatically reflect onto this reminder.'
    },
    suggestions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  emits: ['focus', 'update:modelValue'],
  computed: {
    mobileMode () {
      return this.$q.screen.width < 1024 || this.$q.platform.is.mobile
    },
    invalidEmailError () {
      if (!this.modelValue && !this.defaultEmail) {
        return 'Please enter a valid email'
      }
      return 'This email is invalid'
    }
  },
  methods: {
    onSelectValue (val) {
      this.$emit('update:modelValue', val)
    }
  }
}
</script>
